import ConfirmDialog from '../components/confirm-dialog'
import { useSuretyModel } from '../store/use-surety-popup'

interface TPopupSuretyModel {
    loading?: boolean
}

const PopupSuretyModel = ({ loading = false }: TPopupSuretyModel) => {
    const { onCloseSuretyPopup, initialValues } = useSuretyModel()

    return (
        <ConfirmDialog
            tone={initialValues.tone ?? "primary"}
            title={initialValues.title ?? "Restart this chase?"}
            description={initialValues.description}
            detail={initialValues.detail}
            confirmLabel={initialValues.confirmLabel ?? "Restart"}
            loading={loading}
            onConfirm={initialValues.onClick}
            onCancel={onCloseSuretyPopup}
        />
    )
}

export default PopupSuretyModel
